module.exports = __webpack_public_path__ + "img/type--1-spans--multiple-lang--pt.a1e6d180.jpg";